import React from 'react';
import { SectionLayout } from '@/components/shared/section-layout';

export function EmailMarketingPage() {
  return (
    <SectionLayout title="Email Marketing" />
  );
} 